// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__KIR2R","box":"WorkspacesBox_box__2vtxh","node":"WorkspacesBox_node__2GSp1"};